import React from "react";
import { EditAction } from "components/buttons";
import { Restricted, permissions } from "components/auth";
import { DeleteActionWithModal } from "components/buttons";
import { useMutation } from "@apollo/react-hooks";
import PropTypes from "prop-types";

const ActionButtons = ({ id, customerId, name, mutation, history, deploymentId }) => {
  const [deleteDeployment] = useMutation(mutation);

  return (
    <>
      <Restricted permissions={[permissions.deployment_manage]}>
        <EditAction url={`/deployment/edit/${id}`} />
        <DeleteActionWithModal
          actionButton
          urlOnSuccess="/deployment/list"
          history={history}
          mutation={deleteDeployment}
          descriptionText="app.deployment.dialog.delete.text"
          mutationVariables={{
            deploymentId: id,
            customerId,
          }}
          elementNameInResult="deleteDeployment"
          elementToDelete={name}
        />
      </Restricted>
    </>
  );
};

ActionButtons.propTypes = {
  /**
   * Id del elemento sobre el que se realiza la acción
   **/
  id: PropTypes.string,
  /**
   * Id del customer
   **/
  customerId: PropTypes.string,
  /**
   * Nombre del elemento
   **/
  name: PropTypes.string,
  /**
   * Query gql de borrado del elemento
   **/
  mutation: PropTypes.object.isRequired,
  /**
   * Id del deployment
   **/
  deploymentId: PropTypes.string,
};

export default ActionButtons;
